import React from "react";

const cardStyle = () => {
  return {
    borderRadius: "12px",
    background: "#F8F9FC",
    padding: "32px",
    width: "100%",
    marginBottom: "16px",
  };
};

export default function Card({ children }) {
  return <div style={cardStyle()}>{children}</div>;
}
